import React, { useState, useEffect } from 'react';
import {
  Offcanvas,
  OffcanvasHeader,
  OffcanvasBody,
  Table,
  Input,
  FormGroup,
  Label,
} from 'reactstrap';

const ItemDetailsOffcanvas = ({ isOpen, toggle, itemData }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredItems, setFilteredItems] = useState([]);
  useEffect(() => {
    if (isOpen) {
      setSearchTerm('');
    } else {
      setFilteredItems([]);
    }
  }, [isOpen]);

  useEffect(() => {
    const allItems = itemData?.items || [];
    if (Array.isArray(allItems)) {
      const filtered = allItems.filter((item) =>
        item?.sku?.toLowerCase().includes(searchTerm.toLowerCase())
      );
      setFilteredItems(filtered);
    }
  }, [searchTerm, itemData]);

  return (
    <Offcanvas
      isOpen={isOpen}
      toggle={toggle}
      direction="end"
      style={{ width: '500px' }}
      className="border-start-0 shadow"
    >
      <OffcanvasHeader toggle={toggle} className="border-bottom bg-light py-3">
        <div className="d-flex align-items-center">
          <i className="mdi mdi-information-outline text-primary me-2 fs-4"></i>
          <span className="fw-bold">Items Details</span>
          <span className="mx-2 text-muted fw-normal">|</span>
          <span className="text-secondary fw-bold">{itemData?.to_number || ''}</span>
        </div>
      </OffcanvasHeader>
      <OffcanvasBody className="p-4">
        <FormGroup className="mb-4">
          <Label for="skuSearch" className="form-label fw-semibold text-muted small text-uppercase">
            Search SKU
          </Label>
          <div className="position-relative">
            <Input
              type="text"
              id="skuSearch"
              placeholder="Search by SKU number..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="form-control ps-4"
              style={{ borderRadius: '8px', border: '1px solid #e2e8f0' }}
            />
            <i className="mdi mdi-magnify position-absolute top-50 start-0 translate-middle-y ms-2 text-muted"></i>
          </div>
        </FormGroup>
        
        <div className="table-responsive rounded-3 border">
          <Table className="table table-hover align-middle mb-0">
            <thead className="table-light">
              <tr>
                <th className="py-3 ps-3" style={{ fontSize: '12px', fontWeight: '600', color: '#64748b' }}>SKU</th>
                <th className="py-3 text-center" style={{ fontSize: '12px', fontWeight: '600', color: '#64748b' }}>RESERVED QUANTITY</th>
                <th className="py-3 text-center" style={{ fontSize: '12px', fontWeight: '600', color: '#64748b' }}>APPROVED QUANTITY</th>
              </tr>
            </thead>
            <tbody>
              {filteredItems.length > 0 ? (
                filteredItems.map((item, index) => (
                  <tr key={index}>
                    <td className="ps-3 fw-medium text-dark">{item.sku}</td>
                    <td className="text-center">
                      <span className="badge bg-soft-warning text-warning rounded-pill px-3 py-2">
                        {item.reserved_qty || 0}
                      </span>
                    </td>
                    <td className="text-center">
                      <span className="badge bg-soft-success text-success rounded-pill px-3 py-2">
                        {item.qty || 0}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="2" className="text-center py-5">
                    <div className="text-muted">
                      <i className="mdi mdi-database-off-outline d-block fs-1 mb-2 opacity-25"></i>
                      <span>No items matching your search</span>
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </OffcanvasBody>
    </Offcanvas>
  );
};

export default ItemDetailsOffcanvas;
